import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LangContext, detectLang } from './lang';

const lang = detectLang();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LangContext.Provider value={lang}>
      <App />
    </LangContext.Provider>
  </React.StrictMode>
);

reportWebVitals();
